import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import Sidebar from "Parts/Sidebar";
import Centered from "Parts/Centered";
import Title from "Parts/Title";

export default function Dashboard() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const DETAILS = useSelector((state) => state.users);
  return (
    <div className="flex">
      <Title title="Dashboard"></Title>
      <Sidebar></Sidebar>
      <main className="flex-1">
        <div className="px-16">
          <section className="flex flex-col mt-8">
            <h1 className="text-4xl text-gray-900 font-medium">DASHBOARD</h1>
            <p className="text-lg text-gray-600">
              Hallo <strong>{DETAILS?.name ?? ""}</strong>, Selamat Datang
              kembali di Kelas Seni !
            </p>
          </section>
          <section className="flex flex-col -mt-32">
            <Centered>
              {"Waduh, Halaman masih dalam tahap pengembangan nih, sabar ya ?"}
            </Centered>
          </section>
        </div>
      </main>
    </div>
  );
}
